import React from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function BreadCrumbs() {
  const location = useLocation();
  const vPathName = location.pathname;
  return (
    <div className="container-fluid p-0 mt-0 mb-3 breadcrumb">
      {vPathName === '/Distribution' ? (
        <div>
          <span className="breadcrumb-arrow-inactive ">Distribution</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}
